import { useState } from 'react';
import { useTranslation } from '../../context/LanguageContext';
import type { UnifiedWallet } from '../auth/useWallet';
import { shortenPubkey } from '../lib/evore';
import { ThemeToggle } from './ThemeToggle';
import { LanguagePickerModal } from '../../components/LanguagePickerModal';

export function Header({ wallet }: { wallet: UnifiedWallet }) {
  const { t } = useTranslation();
  const [langOpen, setLangOpen] = useState(false);

  return (
    <nav className="sunset-topnav">
      <div className="sunset-topnav-inner">
        <div className="win98-app-header-logo">
          <span className="win98-app-header-title">{t('sunset.appTitle')}</span>
        </div>

        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
          <button
            className="win98-button win98-nav-button win98-title"
            onClick={() => setLangOpen(true)}
            title={t('sunset.languageTitle')}
            style={{
              width: '28px',
              height: '30px',
              padding: 0,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <i className="fa-solid fa-globe" />
          </button>
          <ThemeToggle />
          {wallet.isConnected && wallet.publicKey && (
            <>
              <span
                className="win98-text-normal sunset-wallet-display"
                title={wallet.publicKey.toBase58()}
                style={{ fontFamily: 'monospace' }}
              >
                <i
                  className={`fa-solid ${
                    wallet.source === 'privy' ? 'fa-envelope' : 'fa-wallet'
                  }`}
                  style={{ marginRight: 6 }}
                />
                {shortenPubkey(wallet.publicKey, 4)}
              </span>
              <button
                className="win98-button"
                onClick={() => void wallet.disconnect()}
                title={t('sunset.signOut')}
              >
                <i className="fa-solid fa-right-from-bracket" />
                <span style={{ marginLeft: 6 }}>{t('sunset.signOut')}</span>
              </button>
            </>
          )}
        </div>
      </div>
      <LanguagePickerModal isOpen={langOpen} onClose={() => setLangOpen(false)} />
    </nav>
  );
}
